module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABqSURBVCiRrdMxDYRQEITh79FBRYIBJODhDCCAAg1gBwkk112CCDxdAR008Hb6+bM7O8tzfdG98F30wQ9tBKzHhiYCNmJFHQGbsaBMGFBlwAbsRcRYSLmAyblaDmQUEHbv6FLW+cMKefsif+7BDCCmZCGUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/images/img_21.png
// module id = jof5
// module chunks = 2 6